import { render, staticRenderFns } from "./TuoterekisteriSelaa.vue?vue&type=template&id=1f2805e5&scoped=true&"
import script from "./TuoterekisteriSelaa.vue?vue&type=script&lang=js&"
export * from "./TuoterekisteriSelaa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2805e5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VNavigationDrawer,VProgressLinear,VSpacer,VToolbar,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f2805e5')) {
      api.createRecord('1f2805e5', component.options)
    } else {
      api.reload('1f2805e5', component.options)
    }
    module.hot.accept("./TuoterekisteriSelaa.vue?vue&type=template&id=1f2805e5&scoped=true&", function () {
      api.rerender('1f2805e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TuoterekisteriSelaa.vue"
export default component.exports